
import { allQRByLocationId } from "../Constants/qrByLocationId";

export const getAllQRByLocationId = (qrByLocationId) => {
    return {
        type: allQRByLocationId.GET_AllQRByLocationId,
        payload: qrByLocationId
    };
};